"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
var base_item_query_class_1 = require("./base-item-query.class");
var MultipleItemQuery = /** @class */ (function (_super) {
    __extends(MultipleItemQuery, _super);
    function MultipleItemQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        return _this;
    }
    /**
     * Gets only item of given type
     * @param type Codename of type to get
     */
    MultipleItemQuery.prototype.type = function (type) {
        this.parameters.push(new models_1.Filters.TypeFilter(type));
        return this;
    };
    /**
     * Gets items of given types (logical or)
     * I.e. get items of either 'Actor' or 'Movie' type
     * @param types Types to get
     */
    MultipleItemQuery.prototype.types = function (types) {
        this.parameters.push(new models_1.Filters.TypeFilter(types));
        return this;
    };
    /**
     * Equals filter condition
     * @param field Element to filter. Example: 'elements.movie'
     * @param value Value to match. Example: 'Kingsman'
     */
    MultipleItemQuery.prototype.equalsFilter = function (field, value) {
        this.parameters.push(new models_1.Filters.EqualsFilter(field, value));
        return this;
    };
    /**
     * All filter
     * @param field Element to filter.
     * @param values Values
     */
    MultipleItemQuery.prototype.allFilter = function (field, values) {
        this.parameters.push(new models_1.Filters.AllFilter(field, values));
        return this;
    };
    /**
     * Any filter
     * @param field Element to filter.
     * @param values Values
     */
    MultipleItemQuery.prototype.anyFilter = function (field, values) {
        this.parameters.push(new models_1.Filters.AnyFilter(field, values));
        return this;
    };
    /**
     * Contains filter
     * @param field Element to filter.
     * @param values Values
     */
    MultipleItemQuery.prototype.containsFilter = function (field, values) {
        this.parameters.push(new models_1.Filters.ContainsFilter(field, values));
        return this;
    };
    /**
     * Greater then filter
     * @param field Element to filter.
     * @param value Value
     */
    MultipleItemQuery.prototype.greaterThanFilter = function (field, value) {
        this.parameters.push(new models_1.Filters.GreaterThanFilter(field, value));
        return this;
    };
    /**
     * Greater then or equals filter
     * @param field Element to filter.
     * @param value Value
     */
    MultipleItemQuery.prototype.greaterThanOrEqualFilter = function (field, value) {
        this.parameters.push(new models_1.Filters.GreaterThanOrEqualFilter(field, value));
        return this;
    };
    /**
     * In filter
     * @param field Element to filter.
     * @param values Values
     */
    MultipleItemQuery.prototype.inFilter = function (field, values) {
        this.parameters.push(new models_1.Filters.Infilter(field, values));
        return this;
    };
    /**
     * Less then filter
     * @param field Element to filter.
     * @param value Value
     */
    MultipleItemQuery.prototype.lessThanFilter = function (field, value) {
        this.parameters.push(new models_1.Filters.LessThanFilter(field, value));
        return this;
    };
    /**
     * @param field Element to filter.
     * @param value Value
     */
    MultipleItemQuery.prototype.lessThanOrEqualFilter = function (field, value) {
        this.parameters.push(new models_1.Filters.LessThanOrEqualFilter(field, value));
        return this;
    };
    /**
     * @param field Element to filter.
     * @param lowerValue Lower value of range (e.g. 2)
     * @param higherValue Higher value of range (e.g. 10)
     */
    MultipleItemQuery.prototype.rangeFilter = function (field, lowerValue, higherValue) {
        this.parameters.push(new models_1.Filters.RangeFilter(field, lowerValue, higherValue));
        return this;
    };
    /**
     * Limits the number of items returned by query
     * @param limit Number of items to load
     */
    MultipleItemQuery.prototype.limitParameter = function (limit) {
        this.parameters.push(new models_1.Parameters.LimitParameter(limit));
        return this;
    };
    /**
     * Orders query based on given field and sort order
     * @param field Element by which to order
     * @param sortOrder Asc/Desc order type
     */
    MultipleItemQuery.prototype.orderParameter = function (field, sortOrder) {
        this.parameters.push(new models_1.Parameters.OrderParameter(field, sortOrder));
        return this;
    };
    /**
     * Sets descending order on given field
     * @param field Element by which to order
     */
    MultipleItemQuery.prototype.orderByDescending = function (field) {
        this.parameters.push(new models_1.Parameters.OrderParameter(field, models_1.SortOrder.desc));
        return this;
    };
    /**
   * Sets Ascending order on given field
   * @param field Element by which to order
   */
    MultipleItemQuery.prototype.orderByAscending = function (field) {
        this.parameters.push(new models_1.Parameters.OrderParameter(field, models_1.SortOrder.asc));
        return this;
    };
    /**
     * Skips the selected number of items
     * @param skip Number of items to skip
     */
    MultipleItemQuery.prototype.skipParameter = function (skip) {
        this.parameters.push(new models_1.Parameters.SkipParameter(skip));
        return this;
    };
    /**
     * Gets the runnable Observable
     */
    MultipleItemQuery.prototype.getObservable = function () {
        return _super.prototype.runMultipleItemsQuery.call(this);
    };
    /**
     * Gets 'Url' representation of query
     */
    MultipleItemQuery.prototype.getUrl = function () {
        return _super.prototype.getMultipleItemsQueryUrl.call(this);
    };
    return MultipleItemQuery;
}(base_item_query_class_1.BaseItemQuery));
exports.MultipleItemQuery = MultipleItemQuery;
//# sourceMappingURL=multiple-item-query.class.js.map